/**
 * @typedef {import('./Response').default} Response
 * @typedef {import('../../../../App/shared/OfferService/OfferFields').default} VendorFields
 */

import { offerService } from '../../../../service-container';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';

/**
 * @param {'domain' | 'group'} role
 * @param {number} [pageNumber]
 * @param {boolean} [isGated]
 * @returns {Response}
 */
export default function useGetAdminVendors(
	role = 'domain',
	pageNumber = 1,
	isGated = false
) {
	const [isGettingData, setIsGettingData] = useState(true);
	const [lastPageNumber, setLastPageNumber] = useState(1);
	const [total, setTotal] = useState(0);
	const [vendors, setVendors] = useState(/** @type {VendorFields[]} */ ([]));

	useEffect(() => {
		if (isGated) {
			setIsGettingData(false);
			return;
		}

		fetchData();
	}, [isGated, pageNumber]);

	async function fetchData() {
		setIsGettingData(true);

		try {
			let response;

			if (role === 'domain') {
				response = await offerService.getDomainOffers(pageNumber);
			} else {
				response = await offerService.getGroupOffers(pageNumber);
			}

			setLastPageNumber(response.pages ?? 1);
			setVendors(response.offers);
			setTotal(response.total ?? 0);
		} catch (error) {
			captureError(error);
		} finally {
			setIsGettingData(false);
		}
	}

	return useMemo(
		() => ({
			data: vendors,
			isGettingData,
			lastPageNumber,
			total,
		}),
		[vendors, isGettingData, lastPageNumber, total]
	);
}
